import i18n from "@/i18n";
import { Organisation } from "./api/organisations";
import { Person } from "./api/persons";
import { Context } from "./contex";
import { EntityType, MetadataProvider } from "./fields/metadata";

export class NavigationProvider {

    static getOrganisationUrl(id: number) {
        return `${Context.urls.mainSystemUrl}/MainMenu/Organisations/OrganisationCard/OrganisationCard.aspx?orgId=${id}`;
    }

    static getOrganisationImageUrl(organisation: Organisation) {
        if (!organisation.OrganisationImageFileExtension) return '';
        return `${Context.urls.mainSystemUrl}/images/customer/C${Context.user.systemId.toString().padStart(6, '0')}/org${organisation.OrganisationId.toString().padStart(8, '0')}.${organisation.OrganisationImageFileExtension}?updated=${organisation.OrganisationUpdatedAt}`;
    }

    static getPersonUrl(id: number) {
        return `${Context.urls.mainSystemUrl}/MainMenu/Persons/PersonView.aspx?eid=${id}`;
    }

    static getPersonImageUrl(person: Person) {
        if (!person.PersonImageFileExtension) return '';
        return `${Context.urls.mainSystemUrl}/images/customer/C${Context.user.systemId.toString().padStart(6, '0')}/per${person.PersonId.toString().padStart(8, '0')}.${person.PersonImageFileExtension}?updated=${person.PersonUpdatedAt}`;
    }

    static getActivityUrl(id: number) {
        return `${Context.urls.mainSystemUrl}/MainMenu/Activities/ActivityView.aspx?eid=${id}`;
    }

    static getOpportunityUrl(id: number) {
        return `${Context.urls.mainSystemUrl}/MainMenu/Opportunities/OpportunityView.aspx?eid=${id}`;
    }

    static getDeliveryUrl(id: number) {
        return `${Context.urls.mainSystemUrl}/MainMenu/Deliveries/DeliveryView.aspx?eid=${id}`;
    }

    static getSupportCaseUrl(id: number) {
        return `${Context.urls.mainSystemUrl}/MainMenu/SupportCases/SupportCasesView.aspx?eid=${id}`;
    }

    static getLicensePageUrl() {
        return `${Context.urls.mainSystemUrl}/Configuration/License.aspx`;
    }


    static getGoogleMapsUrl(address: string) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    }

    static getMicrosoftLoginUrl() {
        const state = btoa(JSON.stringify({
            returnUrl: location.href
        }));
        const callbackParameters = new URLSearchParams({
            client_id: 'webCRM.Addins',
            redirect_uri: `${Context.urls.addinsUrl}/login`,
            response_type: 'code',
            scope: 'openid',
            state
        });
        const ssoParameters = new URLSearchParams({
            returnUrl: `/connect/authorize/callback?${callbackParameters}`,
        });
        return `${Context.urls.loginUrl}/sso/microsoft?${ssoParameters}`;
    }

    static goEmail(email: string, name?: string) {
        if (Office?.context?.mailbox?.displayNewMessageForm!) {
            Office?.context?.mailbox?.displayNewMessageForm({ toRecipients: [{ emailAddress: email, displayName: name || email }] });
        } else {
            this.go(`mailto:${email}`);
        }
    }

    static go(url: string) {
        if (Office?.context?.ui?.openBrowserWindow) {
            Office.context.ui.openBrowserWindow(url);
        } else {
            window.open(url, '_blank');
        }
    }

    static getEntityUrl(entityType: EntityType, entityId: number) {
        switch (entityType) {
            case EntityType.Organisation: return this.getOrganisationUrl(entityId);
            case EntityType.Person: return this.getPersonUrl(entityId);
            case EntityType.Activity: return this.getActivityUrl(entityId);
            case EntityType.Opportunity: return this.getOpportunityUrl(entityId);
            case EntityType.Delivery: return this.getDeliveryUrl(entityId);
            case EntityType.SupportCase: return this.getSupportCaseUrl(entityId);
        }
        return '';
    }

    static getEntityTabs() {
        return [
            { value: EntityType.Activity, label: i18n.tc('terms.activities'), class: 'entity-tab webcrm-activity' },
            { value: EntityType.Opportunity, label: i18n.tc('terms.opportunities'), class: 'entity-tab webcrm-opportunity' },
            { value: EntityType.Delivery, label: i18n.tc('terms.deliveries'), class: 'entity-tab webcrm-delivery' },
            { value: EntityType.SupportCase, label: i18n.tc('terms.support_cases'), class: 'entity-tab webcrm-support' },
        ].filter(t => MetadataProvider.isEntityEnabled(t.value)) as Tab<EntityType>[];
    }
}

export interface Tab<TValue> {
    value: TValue
    label: string
    class?: string
}